/**
 * Email closing phrases matched at line start in `email_visible_plain_cut.ts`
 * (exact line, glued name, or long phrase + space + name). Phrase line + 4 following
 * lines kept. Do NOT wire into {@link REPLY_DELIMITER_REGEX_RULES}.
 */

export const STANDALONE_CLOSING_PHRASES: readonly string[] = [
  "Mit freundlichen Grüßen",
  "Mit freundlichem Gruß",
  "Mit freundlichen Gruss",
  "Mit freundlichem Gruss",
  "Freundlichen Grüßen",
  "Herzliche Grüße",
  "Herzliche Gruesse",
  "Beste Grüße",
  "Beste Gruesse",
  "Viele Grüße",
  "Viele Gruesse",
  "Liebe Grüße",
  "Liebe Gruesse",
  "Freundliche Grüße",
  "Freundliche Gruesse",
  "Mit kollegialen Grüßen",
  "Schöne Grüße",
  "Kind regards",
  "Best regards",
  "Warm regards",
  "With best regards",
  "With kind regards",
  "Yours sincerely",
  "Yours faithfully",
  "Many thanks",
  "Thank you",
  "Thanks and regards",
  "Best wishes",
  "All the best",
  "Regards",
  "Sincerely",
  "Cordially",
  "Respectfully",
  "Cheers",
  "Thanks",
];

function escapeRegexLiteral(fragment: string): string {
  return fragment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * @deprecated Closing phrases are not reply-delimiter regex rules. Use `email_visible_plain_cut.ts`.
 */
export function buildStandaloneClosingLineDelimiterRegex(lineBreak: string): RegExp {
  const LB: string = lineBreak;
  const alternation: string = STANDALONE_CLOSING_PHRASES.map((phrase: string) =>
    escapeRegexLiteral(phrase),
  ).join("|");
  return new RegExp(`${LB}(?:${alternation})\\s*(?:${LB}|$)`, "i");
}
